import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserComponent } from './user.component';
import { UserRoutingModule } from './user-routing.module';
import { FormsModule } from '@angular/forms';
import { UserResolve } from './user.resolve';
import { EditUserModule } from './edit/edit-user.module';
import { AddUserModule } from './add/add-user.module';
import { SharedModule } from '../../../shared/shared.module';
import { AppMaterialModule } from '../../../shared/appMaterial/app-material.module';
import { ListGridModule } from '../../../shared/listGrid/listGrid.module';
import { LoadingModule } from '../../../shared/loading/loading.module';
import { PaginationModule } from '../../../shared/pagination/pagination.module';

@NgModule({
  imports: [
    CommonModule,
    UserRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    AddUserModule,
    EditUserModule,
    ListGridModule,
    LoadingModule,
    PaginationModule,
  ],
  declarations: [UserComponent],
  exports: [UserComponent],
  providers: [UserResolve],
})
export class UserModule {}
